import React, { useState, Suspense } from 'react';
import { IProduct } from '../../../../interfaces/product';
import ProductViewInfo from './product-view-info';
import ProductEditInfo from './procut-edit-info';
import ProductAddStockModal from './product-add-stock-modal';

interface IProps {
  data: IProduct;
  onRefresh: () => void;
}

const ProductInfo = ({ data, onRefresh }: IProps) => {
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  return (
    <div className="flex flex-col gap-3 w-full">
      {!isEdit ? (
        <ProductViewInfo data={data} onEdit={() => setIsEdit(true)} />
      ) : (
        <ProductEditInfo
          data={data}
          onClose={() => {
            setIsEdit(false);
            onRefresh();
          }}
        />
      )}
      <Suspense>
        <ProductAddStockModal
          handleCancel={() => {
            setIsOpen(false);
          }}
          handleOk={() => {
            setIsOpen(false);
          }}
          open={isOpen}
          productId={data?.id}
        />
      </Suspense>
    </div>
  );
};

export default ProductInfo;
